const projects = [
    {
        id: "etikaf",
        title: "Etikaf",
        logo: "/images/etikaf-arab.svg",
        bgColor: "#7A1777",
        image: "",
        link: "https://etikaf.com",
        description: `
Etikaf is a cloud-based mosque management platform designed to streamline communication, scheduling, and digital administration. It includes both a web dashboard and a dedicated Flutter-based mobile app for real-time updates and on-the-go management.

Key Features:
• Mosque administration and activity management  
• Automated content syncing with ETV devices  
• Multi-user and multi-mosque access control  
• Integrated mobile app (Flutter)   
• Real-time notifications and content publishing  
• Secure, scalable backend powered by Firebase  
• Fast and reliable global cloud infrastructure  
`
    },

    {
        id: "etv",
        title: "Etikaf TV",
        logo: "/images/etv-logo.png",
        bgColor: "#222222ff",
        image: "",
        link: "https://etikaf.com/etv",
        description: `
ETV is a digital signage system built for mosques.It displays prayer times, Quran verses, live YouTube broadcasts, videos, posters, and announcements—all fully automated and controlled through the Etikaf platform.

Key Features:
• Automated playlist(posters, videos, Quran, Mecca Live)  
• Auto sleep / wake cycle  
• Real - time content synchronization  
• Offline fallback mode
    `,
    },

    {
        id: "tasmik",
        title: "Tasmik",
        logo: "/images/tasmik.png",
        bgColor: "#dadadaff",
        image: "",
        link: "https://tasmik.com",
        description: `
Tasmik is a Quran learning and recitation tracking platform for schools and religious institutions.Teachers can manage students, track progress, assign surah / ayah targets, and review recitation performance.

Key Features:
• Student and class management  
• Recitation progress tracking  
• Customizable starting surah / ayah  
• Teacher dashboard with live updates  
• Cloud sync with Firebase
    `,
    },

    {
        id: "qurb",
        title: "Qurb.my",
        logo: "/images/qurb.png",
        bgColor: "#007374",
        image: "",
        link: "https://qurb.my",
        description: `
Qurb.my is an online qurban and aqiqah management platform designed for mosques.It enables participants to register, submit payments, view animal status in real - time, and receive digital receipts.

Key Features:
• Online qurban registration  
• Automated payment verification(ToyyibPay)  
• Animal status tracking(Sembelihan, Melapah, Selesai)  
• Admin dashboard for mosques  
• PDF + Excel reporting system
    `,
    },
    {
        id: "labbaicc",
        title: "Labbaicc",
        logo: "/images/labbaicc.png",
        bgColor: "#EDCEAF",
        image: "",
        link: "https://labbai.cc",
        description: `
Labbaicc is a modern umrah & travel itinerary platform designed for agencies, ustaz and jemaah. It centralizes trip templates, daily schedules, flight info, health check-ins, and dynamic content — all accessible on mobile.

Key Features:
• Admin master template builder  
• Ustaz trip planner (select templates, customize days)  
• Jemaah itinerary view (mobile-friendly)  
• Daily health check submissions  
• Jemaah feedback & comment system  
• Real-time trip updates & announcements  
• Multi-organization support 
    `,
    },
    {
        id: "taqwall",
        title: "Taqwall",
        logo: "/images/taqwall.jpg",
        bgColor: "#CCCBD3",
        image: "",
        link: "https://taqwall.com",
        description: `
Taqwall is a smart wall display system for homes, offices, and dedicated indoor spaces. It transforms a TV into a portrait Islamic display showing Live Makkah, calendar, Quran, prayer times, and reminders — all managed through a web dashboard.

Key Features:
• Portrait smart wall display experience  
• Live Makkah integration  
• Prayer times with countdown  
• Quran and translation display  
• Google Calendar sync  
• Scrolling notes and reminders  
• Managed through a web dashboard  
• Dedicated Taqwall Player support
    `,
    },

];

export default projects;
